import {
  Tolgee,
  BackendFetch,
} from "@tolgee/react";
import { FormatIcu } from "@tolgee/format-icu";
import {
  DEFAULT_LANGUAGE,
  getInitialLanguage,
  SUPPORTED_LANGUAGE_TAGS,
} from "src/i18n/languages";

export const tolgee = Tolgee()
  .use(FormatIcu())
  .use(
    BackendFetch({
      prefix: "https://cdn.tolg.ee/852f72aa2c70723490aa2990163525c3",
    }),
  )
  .init({
    language: getInitialLanguage(),
    availableLanguages: SUPPORTED_LANGUAGE_TAGS,
    fallbackLanguage: DEFAULT_LANGUAGE,
  });
